import cn from 'classnames';
import React from 'react';

import styles from './carousel.module.scss';

const CarouselSkeleton: React.FC<
  React.PropsWithChildren<{ readonly className?: string }>
> = ({ className }) => {
  return <div className={cn(styles.skeleton, className)}></div>;
};

export default CarouselSkeleton;
